import React from 'react';

const ProblemDataLoading: React.FC = () => {
  return (
    <label className='text-danger'>Failed to load sample tour</label>
  )
};

export default ProblemDataLoading;